import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController } from 'ionic-angular';

import {RhynoApiProvider} from '../../providers/rhyno-api/rhyno-api';
import {LeistungProvider} from '../../providers/leistung/leistung';

/**
 * Generated class for the ProjectassignmentPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-projectassignment',
  templateUrl: 'projectassignment.html',
})
export class ProjectassignmentPage {
Projekte = [];
  loading: any;
  mode = {create:true};
  projekt: any = {};
  projektControlling: any = {};

  constructor(public navCtrl: NavController, 
  	public navParams: NavParams, 
  	private rhynoApi: RhynoApiProvider,
    public loadingCtrl: LoadingController,
  	public leistungCtrl: LeistungProvider) {

    this.mode = navParams.data;
    this.projekt = navParams.data.data;
	this.getData();

  }
  doRefresh(refresher){
    this.getData();
    refresher.complete();
  }
  getData(){
    this.loading = this.loadingCtrl.create({
      content: 'einen Moment...'
    });
    this.loading.present();

    this.rhynoApi.getProjectassignments(this.projekt).subscribe(
      data => {
      if (data.success){
        this.Projekte = data.data; 
        console.log(data);
      }
      this.loading.dismiss();
    },
      err => {
      console.log(err);
      this.loading.dismiss();
    },
    () => console.log('Projekte Search Complete')
    );


    this.rhynoApi.getProjektcontrolling(this.projekt).subscribe(
      data => {
      if (data.success){
        this.projektControlling = data.data[0];
        if (this.projektControlling.nichtVerrechnet == null){
        	this.projektControlling.nichtVerrechnet = 0;
        }
        if (this.projektControlling.nichtVerrechnetPreis == null){
        	this.projektControlling.nichtVerrechnetPreis = 0;
        }
        if (this.projektControlling.budget){
        	this.projektControlling.progress = 100 / this.projektControlling.budget * ( this.projektControlling.actual + this.projektControlling.nichtVerrechnet )  
        	this.projektControlling.progress = Math.round( this.projektControlling.progress * 10 ) / 10;
        }

        if (this.projektControlling.budgetPreis){
        	this.projektControlling.progressPreis = 100 / this.projektControlling.budgetPreis * ( this.projektControlling.actualPreis  + this.projektControlling.nichtVerrechnetPreis )  
        	this.projektControlling.progressPreis = Math.round( this.projektControlling.progressPreis * 10 ) / 10;
        }
        console.log(data);
      }
    },
      err => {
      console.log(err);
    },
    () => console.log('Projekte Search Complete')
    );

  }

  updateItem(item){
  	this.loading = this.loadingCtrl.create({
      content: 'einen Moment...'
    });
    this.loading.present();

    this.rhynoApi.setProjectassignments(item).subscribe(
      data => {
      if (data['success']){
        //this.Projekte = data.data; 
        console.log(data);
      }
      this.loading.dismiss();
    },
      err => {
      console.log(err);
      this.loading.dismiss();
    },
    () => console.log('Projectassignment update completed')
    );
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad SelectProjectPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/projectassignment/projectassignment.ts